module.exports = __webpack_public_path__ + "img/120.efb5db8d.jpg";